import React, { useCallback } from 'react';
import Grid from '@mui/material/Grid';
import { useEditEventCategory } from '../../../../../redux/incident/EventCategory/hooks/useEditEventCategory';
import { getPolyglot } from '../../../../../i18n';
import CategoryCard from './CategoryCard';

interface PolicyEditCategoriesProps {
  selectedOptions: string[];
  setSelectedOptions: (...args: any[]) => void;
  availableEventIds: string[];
}

function PolicyEditCategories({
  selectedOptions,
  setSelectedOptions,
  availableEventIds,
}: PolicyEditCategoriesProps) {
  const emit = useCallback(
    (newValues: string[]) => {
      setSelectedOptions({
        target: { name: 'filterValues', value: newValues },
      });
    },
    [setSelectedOptions]
  );
  const polyglot = getPolyglot();

  const {
    eventCategories,
    toggleCategory,
    toggleSubCategory,
    selectedCategoryDic,
    selectedSubCategoryDic,
  } = useEditEventCategory(availableEventIds, selectedOptions, emit);

  return (
    <Grid
      container
      spacing={2}
      alignItems="stretch"
      sx={{ marginTop: '0px!important' }}
    >
      {eventCategories.map((category) => (
        <CategoryCard
          key={category.id}
          categoryId={category.id}
          name={
            polyglot.t(`incident.policy.edit.categories.${category.id}`) ??
            category.name_en
          }
          catState={selectedCategoryDic[category.id]}
          subCategories={category.subCategories}
          selectedSubCategoryDic={selectedSubCategoryDic}
          toggleCategory={toggleCategory}
          toggleSubCategory={toggleSubCategory}
        />
      ))}
    </Grid>
  );
}

export default PolicyEditCategories;
